import styled from '@emotion/styled';

export const OrderCardSidebarWrapper = styled.div`
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  width: 100%;
`;
export const AdditionalInfoLine = styled.div`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  display: flex;
  gap: 16px;
  justify-content: space-between;
  align-items: center;
`;
export const CartItemContainer = styled.div`
  display:flex;
  flex-direction: column;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray};
`;